import type { ArchiveDigitizationStatus } from '@type/archive.types'

const STATUS_STYLES: Record<ArchiveDigitizationStatus, { bg: string; text: string; label: string }> = {
  partially_scanned: { bg: '#FFF4E5', text: '#B45309', label: 'Partially Scanned' },
  fully_scanned: { bg: '#ECFDF3', text: '#099C32', label: 'Fully Scanned' },
  physical_only: { bg: '#FEE6E6', text: '#B42318', label: 'Physical Only' }
}

type DigitizationStatusBadgeProps = {
  status: ArchiveDigitizationStatus | string
}

const DigitizationStatusBadge = ({ status }: DigitizationStatusBadgeProps) => {
  const key = status as ArchiveDigitizationStatus
  const style = STATUS_STYLES[key] ?? { bg: '#F3F4F6', text: '#6B7280', label: status.replace(/_/g, ' ') }

  return (
    <span
      className="inline-flex whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium capitalize"
      style={{ backgroundColor: style.bg, color: style.text }}
    >
      {style.label}
    </span>
  )
}

export default DigitizationStatusBadge
